// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2554":"024bde3f","4359":"31d6cfe0","4466":"83880a37","8702":"b5e0015e","9166":"83880a37"}[chunkId] + ".chunk.css";
};